module.exports = __webpack_public_path__ + "static/media/hero-9.c87b99c7.jpg";